import React from 'react'
import style from './HexagonFilled.module.scss'

interface Props {
    children: React.ReactNode
    red?: boolean
    gray?: boolean
    light?: boolean
}

const HexagonFilled = ({ children, light, red, gray }: Props): JSX.Element => {
    return (
        <div
            className={style('hexagon', {
                light,
                red,
                gray,
            })}
        >
            <div className={style.box1} />
            <div className={style.box2}>{children}</div>
            <div className={style.box3} />
        </div>
    )
}

HexagonFilled.defaultProps = {
    red: false,
    gray: false,
    light: false,
}

export default HexagonFilled
